import { toast } from "react-toastify";
import { VENTAS_API } from "../views/MainLayout/components/shared/services/ventas";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const ventasPendientesReducer = (state = null, action) => {
    switch (action.type) {
        case 'ventas-pendientes/fullfilled':
            return action.payload;
        default:
            return state;
    }
};
export const fetchVentasPendientes = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await VENTAS_API.getPendientes()
        const data = await response.data;
        dispatch({ type: 'ventas-pendientes/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

